unit SystemCostGroupsView;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, VCL.TMSFNCCustomScrollControl,
  VCL.TMSFNCGridData, VCL.TMSFNCCustomGrid, VCL.TMSFNCGrid,
  VCL.TMSFNCGridDatabaseAdapter;

type
  TfrmCostGroupsView = class(TForm)
    WebPanel1: TPanel;
    wpButtons: TPanel;
    btnFirst: TSpeedButton;
    btnPrior: TSpeedButton;
    btnNext: TSpeedButton;
    btnLast: TSpeedButton;
    btnInsert: TSpeedButton;
    WebLabel1: TLabel;
    wdsCostGroupDesc: TXDataWebDataSet;
    dsCostGroupDesc: TDataSource;
    wcCostGroup: TXDataWebClient;
    wsbClose: TSpeedButton;
    tmsfncgCostGroups: TTMSFNCGrid;
    dbaCostGroup: TTMSFNCGridDatabaseAdapter;
    wpBottom: TPanel;
    lPageCountMax: TLabel;
    btnPageLeft: TSpeedButton;
    btnPageRight: TSpeedButton;
    ePageCount: TEdit;
    eMaxPageCount: TEdit;
    wcPageCount: TXDataWebClient;
    wdsCostGroupDescDescription: TStringField;
    wdsCostGroupDescSuspended: TBooleanField;
    wdsCostGroupDescCode: TIntegerField;
    WebMessageDlg1: TMessageDlg;
    procedure WebFormCreate(Sender: TObject);
    procedure btnInsertClick(Sender: TObject);
    procedure btnFirstClick(Sender: TObject);
    procedure btnPriorClick(Sender: TObject);
    procedure btnNextClick(Sender: TObject);
    procedure btnLastClick(Sender: TObject);
    procedure btnEditClick(Sender: TObject);
    procedure wsbCloseClick(Sender: TObject);
    procedure tmsfncgCostGroupsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure tmsfncgCostGroupsCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure wdsCostGroupDescAfterOpen(DataSet: TDataSet);
    procedure ePageCountExit(Sender: TObject);
    procedure btnPageRightClick(Sender: TObject);
    procedure btnPageLeftClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }

    iPageCount, iMaxPageCount : Integer;

    procedure LoadData;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDatabaseAdapter);

var
  frmCostGroupsView: TfrmCostGroupsView;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, SystemCostGroupsSetup, share.common;

procedure TfrmCostGroupsView.btnEditClick(Sender: TObject);
  var
  newform : TFrmCostGroupsSetup;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    newform.Free;
  end;
begin
  newform := TFrmCostGroupsSetup.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.iState := 2;
  newform.Showmodal(@AfterShowModal);
end;

procedure TfrmCostGroupsView.btnFirstClick(Sender: TObject);
begin
  wdsCostGroupDesc.First;
end;

procedure TfrmCostGroupsView.btnInsertClick(Sender: TObject);
var
  newform : TFrmCostGroupsSetup;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    newform.Free;
    LoadData;
  end;
begin
  newform := TFrmCostGroupsSetup.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.iState := 1;
  newform.Showmodal(@AfterShowModal);

end;

procedure TfrmCostGroupsView.btnLastClick(Sender: TObject);
begin
  wdsCostGroupDesc.Last;
end;

procedure TfrmCostGroupsView.btnNextClick(Sender: TObject);
begin
  wdsCostGroupDesc.next;
end;

procedure TfrmCostGroupsView.btnPageLeftClick(Sender: TObject);
begin
  if NOT iPageCount <= 0 then
    begin
      Dec(iPageCount);
      LoadData;
    end;
end;

procedure TfrmCostGroupsView.btnPageRightClick(Sender: TObject);
begin
  if iPageCount < iMaxPageCount then
    begin
      Inc(iPageCount);
      LoadData;
    end;
end;

procedure TfrmCostGroupsView.btnPriorClick(Sender: TObject);
begin
  wdsCostGroupDesc.Prior;
end;

procedure TfrmCostGroupsView.ePageCountExit(Sender: TObject);
begin
  if (StrToInt(ePageCount.Text) <= iMaxPageCount) AND (StrToInt(ePageCount.Text) > 0 )  then
    Begin
      iPageCount := StrToInt(ePageCount.Text);
      LoadData
    End
  else
    Begin
      iPageCount := iMaxPageCount;
      LoadData;
    End;
end;

procedure TfrmCostGroupsView.LoadData;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsCostGroupDesc.Close;
      wdsCostGroupDesc.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsCostGroupDesc.Open;
    end;
  procedure OnResult2(Response : TXDataClientResponse);
    begin
      iMaxPageCount := Integer(TJSObject(Response.Result)['value']);
      eMaxPageCount.Text := IntToStr(iMaxPageCount);
      wcCostGroup.RawInvoke('IstfmsSystemService.Get_CostGroups_View', [0,iPageCount], @OnResult);
    end;

begin
  wcPageCount.RawInvoke('IstfmsSystemService.Get_CostGroup_MaxPageCount', [], @OnResult2);
  ePageCount.Text := IntToStr(iPageCount);
end;

procedure TfrmCostGroupsView.tmsfncgCostGroupsCellClick(Sender: TObject; ACol, ARow: Integer);
  var
  newform : TFrmCostGroupsSetup;
  sCost : string;
  bSusp : Boolean;

  procedure OnResult(Value : TModalResult);
    begin
      if Value = mrYes then
        begin
          wcCostGroup.RawInvoke('IstfmsSystemService.Put_CostGroups_Delete',[GetAdapterKey(dbaCostGroup,0,ARow)]);
        end;

      LoadData;
    end;
  procedure AfterCreate(AForm: TObject);
    begin
      with (Aform as TFrmCostGroupsSetup) do
        begin
          iState := 2;

          LoadData;
        end;
    end;

  Procedure GetCostSuspended;
    var
      d: TTMSFNCGridDataBaseAdapterOpen;
      ar, c, r: Integer;
      fCost, fSuspended : TField;
    Begin

    d := TTMSFNCGridDataBaseAdapterOpen(dbaCostGroup);
    if d.CheckDataSet then
      begin
        ar := d.DataLink.ActiveRecord;
        try
          d.SetActiveRecord(ARow);
          fCost := d.FieldAtColumn[1];
          fSuspended := d.FieldAtColumn[2];
          if Assigned(fCost) then
           newform.sCostGroup  := fCost.AsString;
          if Assigned(fSuspended) then
            newform.bSuspended := fSuspended.AsBoolean;
        finally
          d.DataLink.ActiveRecord := ar;
        end;
      end;
  end;

begin
   If ARow <= tmsfncgCostGroups.FixedRows - 1 then
    Exit;

   If ACol = 3 then
    begin
      newform := TFrmCostGroupsSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.Showmodal;
      //GetCostSuspended;
      newform.iState := 2;
      newform.iPK := GetAdapterKey(dbaCostGroup,0,ARow);
    end;

   If ACol = 4 then
    begin
      WebMessageDlg1.ShowDialog('Do you want to delete this record?', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    end;

end;

procedure TfrmCostGroupsView.tmsfncgCostGroupsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);

  var
    ilRow,
    ilCol,
    ar : Integer;
    d : TTMSFNCGridDataBaseAdapterOpen;
    fName : TField;
    Bitmap : TTMSFNCBitmap;
begin
  ilRow := ARow;

  If (ilRow <= tmsfncgCostGroups.FixedRows - 1) then
    Exit;

  ilCol := ACol;

  If ilCol = 3 then
    begin
      d := TTMSFNCGridDataBaseAdapterOpen(dbaCostGroup);
      if d.CheckDataSet then
        begin
          ar := d.DataLink.ActiveRecord;
          try
            d.SetActiveRecord(ilRow);
            fName := d.FieldAtColumn[1];
            if Assigned(fName) then
              begin
                If Trim(fName.AsString) <> '' then
                  begin
                    Bitmap := TTMSFNCBitmap.Create;
                    Bitmap.LoadFromURL('images/buttons/edit.svg');
                    tmsfncgCostGroups.AddBitmap(3,ilRow,Bitmap);
                    Bitmap.Free;
                  end;
              end;
          finally
            d.DataLink.ActiveRecord := ar;
          end;
        end;
    end;

    If ilCol = 4 then
    begin
      d := TTMSFNCGridDataBaseAdapterOpen(dbaCostGroup);
      if d.CheckDataSet then
        begin
          ar := d.DataLink.ActiveRecord;
          try
            d.SetActiveRecord(ilRow);
            fName := d.FieldAtColumn[1];
            if Assigned(fName) then
              begin
                If Trim(fName.AsString) <> '' then
                  begin
                    Bitmap := TTMSFNCBitmap.Create;
                    Bitmap.LoadFromURL('images/buttons/delete.svg');
                    tmsfncgCostGroups.AddBitmap(4,ilRow,Bitmap);
                    Bitmap.Free;
                  end;
              end;
          finally
            d.DataLink.ActiveRecord := ar;
          end;
        end;
    end;

end;

procedure TfrmCostGroupsView.wdsCostGroupDescAfterOpen(DataSet: TDataSet);
begin
  tmsfncgCostGroups.SetFocus;
  wdsCostGroupDesc.First;
end;

procedure TfrmCostGroupsView.WebFormCreate(Sender: TObject);
begin
  //LoadData;
  iPageCount := 1;
  ePageCount.Text := '1';
end;

procedure TfrmCostGroupsView.WebFormShow(Sender: TObject);
begin
  LoadData;
end;

procedure TfrmCostGroupsView.wsbCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmCostGroupsView.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  wpButtons := TPanel.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnPrior := TSpeedButton.Create(Self);
  btnNext := TSpeedButton.Create(Self);
  btnLast := TSpeedButton.Create(Self);
  btnInsert := TSpeedButton.Create(Self);
  wsbClose := TSpeedButton.Create(Self);
  tmsfncgCostGroups := TTMSFNCGrid.Create(Self);
  dbaCostGroup := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  wpBottom := TPanel.Create(Self);
  lPageCountMax := TLabel.Create(Self);
  btnPageLeft := TSpeedButton.Create(Self);
  btnPageRight := TSpeedButton.Create(Self);
  ePageCount := TEdit.Create(Self);
  eMaxPageCount := TEdit.Create(Self);
  wdsCostGroupDesc := TXDataWebDataSet.Create(Self);
  wdsCostGroupDescDescription := TStringField.Create(Self);
  wdsCostGroupDescSuspended := TBooleanField.Create(Self);
  wdsCostGroupDescCode := TIntegerField.Create(Self);
  dsCostGroupDesc := TDataSource.Create(Self);
  wcCostGroup := TXDataWebClient.Create(Self);
  wcPageCount := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  wpButtons.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnLast.BeforeLoadDFMValues;
  btnInsert.BeforeLoadDFMValues;
  wsbClose.BeforeLoadDFMValues;
  tmsfncgCostGroups.BeforeLoadDFMValues;
  dbaCostGroup.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  wpBottom.BeforeLoadDFMValues;
  lPageCountMax.BeforeLoadDFMValues;
  btnPageLeft.BeforeLoadDFMValues;
  btnPageRight.BeforeLoadDFMValues;
  ePageCount.BeforeLoadDFMValues;
  eMaxPageCount.BeforeLoadDFMValues;
  wdsCostGroupDesc.BeforeLoadDFMValues;
  wdsCostGroupDescDescription.BeforeLoadDFMValues;
  wdsCostGroupDescSuspended.BeforeLoadDFMValues;
  wdsCostGroupDescCode.BeforeLoadDFMValues;
  dsCostGroupDesc.BeforeLoadDFMValues;
  wcCostGroup.BeforeLoadDFMValues;
  wcPageCount.BeforeLoadDFMValues;
  try
    Name := 'frmCostGroupsView';
    Width := 710;
    Height := 400;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 710;
    WebPanel1.Height := 400;
    WebPanel1.Align := alClient;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 710;
    WebLabel1.Height := 25;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Costing Groups';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -18;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    wpButtons.SetParentComponent(WebPanel1);
    wpButtons.Name := 'wpButtons';
    wpButtons.Left := 0;
    wpButtons.Top := 25;
    wpButtons.Width := 710;
    wpButtons.Height := 60;
    wpButtons.Align := alTop;
    wpButtons.BorderStyle := bsNone;
    wpButtons.ChildOrder := 1;
    wpButtons.Color := clSilver;
    wpButtons.TabOrder := 0;
    btnFirst.SetParentComponent(wpButtons);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 235;
    btnFirst.Top := 6;
    btnFirst.Width := 45;
    btnFirst.Height := 43;
    btnFirst.Caption := '<<';
    btnFirst.Color := clNone;
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.TabOrder := 0;
    btnFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnFirst, Self, 'OnClick', 'btnFirstClick');
    btnPrior.SetParentComponent(wpButtons);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 286;
    btnPrior.Top := 6;
    btnPrior.Width := 45;
    btnPrior.Height := 43;
    btnPrior.Caption := '<';
    btnPrior.Color := clNone;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.TabOrder := 1;
    btnPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrior, Self, 'OnClick', 'btnPriorClick');
    btnNext.SetParentComponent(wpButtons);
    btnNext.Name := 'btnNext';
    btnNext.Left := 337;
    btnNext.Top := 6;
    btnNext.Width := 45;
    btnNext.Height := 43;
    btnNext.Caption := '>';
    btnNext.Color := clNone;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.TabOrder := 2;
    btnNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnNext, Self, 'OnClick', 'btnNextClick');
    btnLast.SetParentComponent(wpButtons);
    btnLast.Name := 'btnLast';
    btnLast.Left := 388;
    btnLast.Top := 6;
    btnLast.Width := 45;
    btnLast.Height := 43;
    btnLast.Caption := '>>';
    btnLast.Color := clNone;
    btnLast.HeightPercent := 100.000000000000000000;
    btnLast.TabOrder := 3;
    btnLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnLast, Self, 'OnClick', 'btnLastClick');
    btnInsert.SetParentComponent(wpButtons);
    btnInsert.Name := 'btnInsert';
    btnInsert.Left := 439;
    btnInsert.Top := 6;
    btnInsert.Width := 45;
    btnInsert.Height := 43;
    btnInsert.Caption := '+';
    btnInsert.Color := clNone;
    btnInsert.HeightPercent := 100.000000000000000000;
    btnInsert.TabOrder := 4;
    btnInsert.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsert, Self, 'OnClick', 'btnInsertClick');
    wsbClose.SetParentComponent(wpButtons);
    wsbClose.Name := 'wsbClose';
    wsbClose.Left := 645;
    wsbClose.Top := 6;
    wsbClose.Width := 45;
    wsbClose.Height := 43;
    wsbClose.Caption := 'X';
    wsbClose.Color := clNone;
    wsbClose.HeightPercent := 100.000000000000000000;
    wsbClose.TabOrder := 5;
    wsbClose.WidthPercent := 100.000000000000000000;
    SetEvent(wsbClose, Self, 'OnClick', 'wsbCloseClick');
    tmsfncgCostGroups.SetParentComponent(WebPanel1);
    tmsfncgCostGroups.Name := 'tmsfncgCostGroups';
    tmsfncgCostGroups.Left := 0;
    tmsfncgCostGroups.Top := 85;
    tmsfncgCostGroups.Width := 710;
    tmsfncgCostGroups.Height := 274;
    tmsfncgCostGroups.Align := alClient;
    tmsfncgCostGroups.ParentDoubleBuffered := False;
    tmsfncgCostGroups.DoubleBuffered := True;
    tmsfncgCostGroups.TabOrder := 1;
    tmsfncgCostGroups.DefaultRowHeight := 40.000000000000000000;
    tmsfncgCostGroups.FixedColumns := 0;
    tmsfncgCostGroups.RowCount := 1;
    tmsfncgCostGroups.Options.Bands.Enabled := True;
    tmsfncgCostGroups.Options.Editing.CalcFormat := '%g';
    tmsfncgCostGroups.Options.Grouping.CalcFormat := '%g';
    tmsfncgCostGroups.Options.Grouping.GroupCountFormat := '(%d)';
    tmsfncgCostGroups.Options.IO.XMLEncoding := 'ISO-8859-1';
    tmsfncgCostGroups.Options.Mouse.ClickMargin := 0;
    tmsfncgCostGroups.Options.Mouse.ColumnSizeMargin := 6;
    tmsfncgCostGroups.Options.Mouse.RowSizeMargin := 6;
    tmsfncgCostGroups.Adapter := dbaCostGroup;
    tmsfncgCostGroups.Columns.Clear;
    with tmsfncgCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Name := 'Code';
      Width := 0.000000000000000000;
    end;
    with tmsfncgCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Name := 'Description';
      Width := 68.000000000000000000;
    end;
    with tmsfncgCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Name := 'Suspended';
      Width := 0.000000000000000000;
    end;
    with tmsfncgCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    with tmsfncgCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 68.000000000000000000;
    end;
    tmsfncgCostGroups.DefaultFont.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.DefaultFont.Color := clBlack;
    tmsfncgCostGroups.DefaultFont.Height := -11;
    tmsfncgCostGroups.DefaultFont.Name := 'Segoe UI';
    tmsfncgCostGroups.DefaultFont.Style := [];
    tmsfncgCostGroups.TopRow := 1;
    tmsfncgCostGroups.Appearance.FixedLayout.Fill.Color := 16380654;
    tmsfncgCostGroups.Appearance.FixedLayout.Fill.ColorTo := 16382457;
    tmsfncgCostGroups.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.FixedLayout.Font.Color := 4539717;
    tmsfncgCostGroups.Appearance.FixedLayout.Font.Height := -13;
    tmsfncgCostGroups.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.FixedLayout.Font.Style := [fsBold];
    tmsfncgCostGroups.Appearance.NormalLayout.Fill.Color := 16578806;
    tmsfncgCostGroups.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.NormalLayout.Font.Color := 8026746;
    tmsfncgCostGroups.Appearance.NormalLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.NormalLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.GroupLayout.Fill.Color := 12817262;
    tmsfncgCostGroups.Appearance.GroupLayout.Fill.ColorTo := 15385233;
    tmsfncgCostGroups.Appearance.GroupLayout.Stroke.Color := 15987699;
    tmsfncgCostGroups.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.GroupLayout.Font.Color := clBlack;
    tmsfncgCostGroups.Appearance.GroupLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.GroupLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.SummaryLayout.Fill.Color := 14009785;
    tmsfncgCostGroups.Appearance.SummaryLayout.Fill.ColorTo := 15385233;
    tmsfncgCostGroups.Appearance.SummaryLayout.Stroke.Color := 15987699;
    tmsfncgCostGroups.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.SummaryLayout.Font.Color := clBlack;
    tmsfncgCostGroups.Appearance.SummaryLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.SummaryLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.SelectedLayout.Fill.Color := 16441019;
    tmsfncgCostGroups.Appearance.SelectedLayout.Fill.ColorTo := 15385233;
    tmsfncgCostGroups.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.SelectedLayout.Font.Color := 4539717;
    tmsfncgCostGroups.Appearance.SelectedLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.SelectedLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.FocusedLayout.Fill.Color := 16039284;
    tmsfncgCostGroups.Appearance.FocusedLayout.Fill.ColorTo := 15385233;
    tmsfncgCostGroups.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.FocusedLayout.Font.Color := 4539717;
    tmsfncgCostGroups.Appearance.FocusedLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.FocusedLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Fill.ColorTo := 15385233;
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.FixedSelectedLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.BandLayout.Fill.Color := 16711679;
    tmsfncgCostGroups.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    tmsfncgCostGroups.Appearance.BandLayout.Font.Color := 8026746;
    tmsfncgCostGroups.Appearance.BandLayout.Font.Height := -11;
    tmsfncgCostGroups.Appearance.BandLayout.Font.Name := 'Segoe UI';
    tmsfncgCostGroups.Appearance.BandLayout.Font.Style := [];
    tmsfncgCostGroups.Appearance.ProgressLayout.Color := 15385233;
    tmsfncgCostGroups.Appearance.ProgressLayout.Format := '%.0f%%';
    tmsfncgCostGroups.LeftCol := 1;
    tmsfncgCostGroups.ScrollMode := scmItemScrolling;
    tmsfncgCostGroups.DesignTimeSampleData := True;
    SetEvent(tmsfncgCostGroups, Self, 'OnGetCellLayout', 'tmsfncgCostGroupsGetCellLayout');
    SetEvent(tmsfncgCostGroups, Self, 'OnCellClick', 'tmsfncgCostGroupsCellClick');
    dbaCostGroup.SetParentComponent(tmsfncgCostGroups);
    dbaCostGroup.Name := 'dbaCostGroup';
    dbaCostGroup.Left := 262;
    dbaCostGroup.Top := 128;
    dbaCostGroup.Width := 26;
    dbaCostGroup.Height := 26;
    dbaCostGroup.Visible := True;
    dbaCostGroup.Active := True;
    dbaCostGroup.Grid := tmsfncgCostGroups;
    dbaCostGroup.DataSource := dsCostGroupDesc;
    dbaCostGroup.Columns.Clear;
    with dbaCostGroup.Columns.Add do
    begin
      FieldName := 'Code';
      Header := 'Code';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostGroup.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Description';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostGroup.Columns.Add do
    begin
      FieldName := 'Suspended';
      Header := 'Suspended';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostGroup.Columns.Add do
    begin
      Header := 'Edit ';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with dbaCostGroup.Columns.Add do
    begin
      Header := 'Delete';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    dbaCostGroup.AutoCreateColumns := False;
    dbaCostGroup.AutoRemoveColumns := False;
    WebMessageDlg1.SetParentComponent(tmsfncgCostGroups);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 439;
    WebMessageDlg1.Top := 136;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    wpBottom.SetParentComponent(WebPanel1);
    wpBottom.Name := 'wpBottom';
    wpBottom.Left := 0;
    wpBottom.Top := 359;
    wpBottom.Width := 710;
    wpBottom.Height := 41;
    wpBottom.Align := alBottom;
    wpBottom.BorderStyle := bsNone;
    wpBottom.ChildOrder := 2;
    wpBottom.Color := clSilver;
    wpBottom.TabOrder := 2;
    lPageCountMax.SetParentComponent(wpBottom);
    lPageCountMax.Name := 'lPageCountMax';
    lPageCountMax.Left := 74;
    lPageCountMax.Top := 14;
    lPageCountMax.Width := 15;
    lPageCountMax.Height := 15;
    lPageCountMax.Caption := 'OF';
    lPageCountMax.HeightPercent := 100.000000000000000000;
    lPageCountMax.WidthPercent := 100.000000000000000000;
    btnPageLeft.SetParentComponent(wpBottom);
    btnPageLeft.Name := 'btnPageLeft';
    btnPageLeft.Left := 14;
    btnPageLeft.Top := 6;
    btnPageLeft.Width := 26;
    btnPageLeft.Height := 26;
    btnPageLeft.Color := clNone;
    btnPageLeft.GlyphURL := 'images/buttons/prior.svg';
    btnPageLeft.GlyphSize := 20;
    btnPageLeft.HeightPercent := 100.000000000000000000;
    btnPageLeft.TabOrder := 0;
    btnPageLeft.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageLeft, Self, 'OnClick', 'btnPageLeftClick');
    btnPageRight.SetParentComponent(wpBottom);
    btnPageRight.Name := 'btnPageRight';
    btnPageRight.Left := 120;
    btnPageRight.Top := 8;
    btnPageRight.Width := 26;
    btnPageRight.Height := 26;
    btnPageRight.Color := clNone;
    btnPageRight.GlyphURL := 'images/buttons/next.svg';
    btnPageRight.GlyphSize := 20;
    btnPageRight.HeightPercent := 100.000000000000000000;
    btnPageRight.TabOrder := 1;
    btnPageRight.WidthPercent := 100.000000000000000000;
    SetEvent(btnPageRight, Self, 'OnClick', 'btnPageRightClick');
    ePageCount.SetParentComponent(wpBottom);
    ePageCount.Name := 'ePageCount';
    ePageCount.Left := 46;
    ePageCount.Top := 9;
    ePageCount.Width := 25;
    ePageCount.Height := 24;
    ePageCount.Alignment := taCenter;
    ePageCount.ChildOrder := 2;
    ePageCount.EditType := weNumeric;
    ePageCount.HeightPercent := 100.000000000000000000;
    ePageCount.WidthPercent := 100.000000000000000000;
    SetEvent(ePageCount, Self, 'OnExit', 'ePageCountExit');
    eMaxPageCount.SetParentComponent(wpBottom);
    eMaxPageCount.Name := 'eMaxPageCount';
    eMaxPageCount.Left := 92;
    eMaxPageCount.Top := 9;
    eMaxPageCount.Width := 25;
    eMaxPageCount.Height := 24;
    eMaxPageCount.Alignment := taCenter;
    eMaxPageCount.ChildOrder := 2;
    eMaxPageCount.EditType := weNumeric;
    eMaxPageCount.HeightPercent := 100.000000000000000000;
    eMaxPageCount.ReadOnly := True;
    eMaxPageCount.WidthPercent := 100.000000000000000000;
    wdsCostGroupDesc.SetParentComponent(Self);
    wdsCostGroupDesc.Name := 'wdsCostGroupDesc';
    wdsCostGroupDesc.AfterOpen := wdsCostGroupDescAfterOpen;
    wdsCostGroupDesc.Connection := dmData.dbConnect;
    wdsCostGroupDesc.Left := 376;
    wdsCostGroupDesc.Top := 141;
    wdsCostGroupDescDescription.SetParentComponent(wdsCostGroupDesc);
    wdsCostGroupDescDescription.Name := 'wdsCostGroupDescDescription';
    wdsCostGroupDescDescription.FieldName := 'Description';
    wdsCostGroupDescSuspended.SetParentComponent(wdsCostGroupDesc);
    wdsCostGroupDescSuspended.Name := 'wdsCostGroupDescSuspended';
    wdsCostGroupDescSuspended.FieldName := 'Suspended';
    wdsCostGroupDescCode.SetParentComponent(wdsCostGroupDesc);
    wdsCostGroupDescCode.Name := 'wdsCostGroupDescCode';
    wdsCostGroupDescCode.FieldName := 'Code';
    dsCostGroupDesc.SetParentComponent(Self);
    dsCostGroupDesc.Name := 'dsCostGroupDesc';
    dsCostGroupDesc.AutoEdit := False;
    dsCostGroupDesc.DataSet := wdsCostGroupDesc;
    dsCostGroupDesc.Left := 496;
    dsCostGroupDesc.Top := 141;
    wcCostGroup.SetParentComponent(Self);
    wcCostGroup.Name := 'wcCostGroup';
    wcCostGroup.Connection := dmData.dbConnect;
    wcCostGroup.Left := 264;
    wcCostGroup.Top := 141;
    wcPageCount.SetParentComponent(Self);
    wcPageCount.Name := 'wcPageCount';
    wcPageCount.Connection := dmData.dbConnect;
    wcPageCount.Left := 352;
    wcPageCount.Top := 205;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    wpButtons.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnLast.AfterLoadDFMValues;
    btnInsert.AfterLoadDFMValues;
    wsbClose.AfterLoadDFMValues;
    tmsfncgCostGroups.AfterLoadDFMValues;
    dbaCostGroup.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    wpBottom.AfterLoadDFMValues;
    lPageCountMax.AfterLoadDFMValues;
    btnPageLeft.AfterLoadDFMValues;
    btnPageRight.AfterLoadDFMValues;
    ePageCount.AfterLoadDFMValues;
    eMaxPageCount.AfterLoadDFMValues;
    wdsCostGroupDesc.AfterLoadDFMValues;
    wdsCostGroupDescDescription.AfterLoadDFMValues;
    wdsCostGroupDescSuspended.AfterLoadDFMValues;
    wdsCostGroupDescCode.AfterLoadDFMValues;
    dsCostGroupDesc.AfterLoadDFMValues;
    wcCostGroup.AfterLoadDFMValues;
    wcPageCount.AfterLoadDFMValues;
  end;
end;

end.